// Password.js --https://alphabeta4success.com
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username");
  const userType = sessionStorage.getItem("userType");  
  const SessionUserId = sessionStorage.getItem("userId");
  const userImage = "https://broken-link.com/avatar.png";

  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [istClock, setIstClock] = useState("");
  const [oldPasswords, setOldPasswords] = useState({});
  const [passwords, setPasswords] = useState({});
  const [confirmPasswords, setConfirmPasswords] = useState({});
  const [showPassword, setShowPassword] = useState({});

  // Fetch users
  const fetchCurrentUsers = useCallback(async () => {
    try {
      //const res = await axios.get(`http://localhost:8000/api/inactiveusers/${SessionUserId}`);
      const res = await axios.get(`https://alphabeta4success.com/api/inactiveusers/${SessionUserId}`);
      // Normalize response to an array
      const usersArray = Array.isArray(res.data) ? res.data : res.data.data || [];
      setUsers(usersArray);
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setUsers([]);
    }
  }, [SessionUserId]);

  useEffect(() => {
      fetchCurrentUsers();
      const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);

    return () => {
      clearInterval(clockInterval);
    };
  }, [fetchCurrentUsers]);

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchCurrentUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      const usersArray = Array.isArray(res.data) ? res.data : res.data.data || [];
      setUsers(usersArray);
    } catch (err) {
      console.error(err);
    }
  }; 

  const resetPassword = async (userId) => {
    try {
      const oldPassword = oldPasswords[userId];
      const newPassword = passwords[userId];
      const confirmPassword = confirmPasswords[userId];
    
       // Password Validation
      if (userType === "Admin")
        {
          if (!newPassword || !confirmPassword) {
            alert("new and confirm password fields are required");
            return;
          }
        }
        else{
          if (!oldPassword || !newPassword || !confirmPassword) {
            alert("All password fields are required");
            return;
          }
        }
    
      if (newPassword !== confirmPassword) {
        alert("New passwords do not match");
        return;
      }
  
      if (!validatePassword(newPassword)) {
        alert(
          "Password must be at least 8 characters and include uppercase, lowercase, number and special character."
        );
        return;
      }
  
      if (!window.confirm("Confirm password reset?")) return;
      //const response = await axios.put(`http://localhost:8000/api/reset-password/${userId}`, 
      const response = await axios.put(`https://alphabeta4success.com/api/reset-password/${userId}`,
        {
          oldPassword,
          newPassword,
          confirmPassword
        }
      );
  
      alert(response.data.message);
  
      // Clear inputs
      setOldPasswords(prev => ({ ...prev, [userId]: "" }));
      setPasswords(prev => ({ ...prev, [userId]: "" }));
      setConfirmPasswords(prev => ({ ...prev, [userId]: "" }));
  
      // Auto logout if backend signals
      if (response.data.forceLogout) {
        sessionStorage.clear();
        window.location.href = "/Signin";
      }
  
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Password reset failed");
    }
  };  

  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const upperCase = /[A-Z]/.test(password);
    const lowerCase = /[a-z]/.test(password);
    const number = /[0-9]/.test(password);
    const specialChar = /[\W_]/.test(password);
  
    return minLength && upperCase && lowerCase && number && specialChar;
  };

  const togglePasswordVisibility = (userId, field) => {
    setShowPassword(prev => ({
      ...prev,
      [`${userId}_${field}`]: !prev[`${userId}_${field}`]
    }));
  };
  
  const deactivate = async (userId) => {
    if (!window.confirm("Are you sure you want to deactivate this user?")) return;
    try {
      //await axios.delete(`http://localhost:8000/api/deleteusers/${userId}`);
      await axios.delete(`https://alphabeta4success.com/api/deleteusers/${userId}`);
      alert("User deactivated successfully");
      fetchCurrentUsers();
    } catch (err) {
      console.error(err);
      alert("Failed to deactivate user");
    }
  };

  return (
    <div>
      {/* Sidebar */}
      <section id="sidebar">
        <Link to="#" className="brand">
        <img
          src="/Assets/images/AB4S_logo.png"
          alt="AB4S"
          className="sidebar-logo"
        />
        </Link>
        {userType === "Admin" && (
        <> 
        <ul className="side-menu top">
          <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><a href="https://alphabeta4success.com/action.html" target="_blank"
              rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
          <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
          <li><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
          <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
          <li className="active"><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
        </>
        )}

        {userType === "Tutor" && (
        <> 
        <ul className="side-menu top">
          <li><Link to="/TutorDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
          <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
          <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
          <li className="active"><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
          <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
        </ul>
        <ul className="side-menu">
          <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
          <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
        </ul>
        </>
        )}
      </section>

      {/* Content */}
      <section id="content">
        <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input
                type="search"
                placeholder="Search by Username..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="search-btn"> <i className="bx bx-search"></i> </button>
            </div>
          </form>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>

        <main>
          <div className="head-title">
            <div className="left">
              <h2>Reset Password</h2>
              <div className="table-data">
                <table className="user-table">
                  <thead>
                    <tr>
                      <th>UserID</th>
                      <th>Name</th>
                      <th>Old Password</th>
                      <th>New Password</th>
                      <th>Confirm Password</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(user => (
                      <tr key={user.UserID}>
                      <td>{user.UserID}</td>
                      <td>{user.FirstName} {user.LastName}</td>
                
                      <td>
                      <input
                        type={showPassword[`${user.UserID}_old`] ? "text" : "password"}
                        placeholder="Old Password"
                        value={oldPasswords[user.UserID] || ""}
                        onChange={(e) =>
                          setOldPasswords(prev => ({ ...prev, [user.UserID]: e.target.value }))
                        }
                      />
                      <span className="eye-icon"
                        onClick={() => togglePasswordVisibility(user.UserID, "old")}
                      >
                        {showPassword[`${user.UserID}_old`] ? "👁️" : "👁️"}
                      </span>
                      </td>
                
                      <td>
                      <input
                        type={showPassword[`${user.UserID}_new`] ? "text" : "password"}
                        placeholder="New Password"
                        value={passwords[user.UserID] || ""}
                        onChange={(e) =>
                          setPasswords(prev => ({ ...prev, [user.UserID]: e.target.value }))
                        }
                      />

                      <span className="eye-icon"
                        onClick={() => togglePasswordVisibility(user.UserID, "new")}
                      >
                        {showPassword[`${user.UserID}_new`] ? "👁️" : "👁️"}
                      </span>
                      </td>
                
                      <td>
                      <input
                        type={showPassword[`${user.UserID}_confirm`] ? "text" : "password"}
                        placeholder="Confirm Password"
                        value={confirmPasswords[user.UserID] || ""}
                        onChange={(e) =>
                          setConfirmPasswords(prev => ({ ...prev, [user.UserID]: e.target.value }))
                        }
                      />

                      <span className="eye-icon"
                        onClick={() => togglePasswordVisibility(user.UserID, "confirm")}
                      >
                        {showPassword[`${user.UserID}_confirm`] ? "👁️" : "👁️"}
                      </span>
                      </td>
                      <td>
                        <button className="btn-demo" onClick={() => resetPassword(user.UserID)}>Reset</button>
                      </td>
                    </tr>
                    ))}
                    {users.length === 0 && (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>No users found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default ResetPassword;
